import React, { FC, Suspense } from 'react';
import { Icon, IconSize, Box, useSideSheetState } from '@bechtel/gds';
import { SuspenseLoader } from '@bechtel/client-common';
import { MilestoneAttachmentActionProps } from '../action/types';
import { MilestoneActionButtonStyled } from '../action/styled';
import MilestoneAttachment from './attachment-sidesheet';

export const MilestoneAttachmentAction: FC<MilestoneAttachmentActionProps> = ({ milestone, status, isInverted }) => {
  const { visible, open, close } = useSideSheetState(false);

  return (
    <Box ml={{ sm: '400' }}>
      <MilestoneActionButtonStyled
        onClick={() => {
          open();
        }}
        status={status}
        isInverted={isInverted}
      >
        <Icon icon="paperclip" size={IconSize.MEDIUM} />
      </MilestoneActionButtonStyled>

      {visible && (
        <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
          <MilestoneAttachment milestone={milestone} closeModal={close} />
        </Suspense>
      )}
    </Box>
  );
};
